export const SET_AUTHENTICATED_USER = 'SET_AUTHENTICATED_USER';
export const DELETE_AUTHENTICATED_USER = 'DELETE_AUTHENTICATED_USER';
